import { useState } from 'react';
import { toast } from 'sonner';
import { founderAdminApi } from '@/lib/founderApi';
import { errMsg } from '@/lib/digitalApi';

const LABELS = { available: 'Available (not used)', pending: 'Checkout created, awaiting your payment', used: 'Used: paid and permanently disabled', disabled: 'Permanently disabled' };

export const LiveTestCard = ({ status, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const closed = status === 'used' || status === 'disabled';
  const run = async (fn, msg) => {
    if (!window.confirm(msg)) return;
    setBusy(true);
    try { await fn(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false); onChanged();
  };
  const start = () => run(async () => { window.location.href = (await founderAdminApi.liveTestCheckout()).checkout_url; },
    'Open a $1 Stripe checkout for your admin account? You will complete the payment yourself. Nothing is charged automatically.');
  const disable = () => run(() => founderAdminApi.liveTestDisable(), 'Permanently disable the $1 live test? This cannot be undone.');
  return (
    <div className="mt-6 bg-white border border-[#eae4d8] rounded-xl p-5 flex flex-wrap items-center justify-between gap-4" data-testid="fb-live-test-card">
      <div>
        <div className="text-[10px] tracking-[0.22em] uppercase text-[#888]">Admin $1 live test · single use</div>
        <div className="mt-1 text-lg" data-testid="fb-live-test-status">{LABELS[status] || status}</div>
      </div>
      {!closed && (
        <div className="flex gap-3">
          <button onClick={start} disabled={busy} className="text-xs uppercase tracking-[0.14em] px-5 py-2 rounded-full bg-[#111] text-white" data-testid="fb-live-test-start">Start $1 Test Checkout</button>
          <button onClick={disable} disabled={busy} className="text-xs uppercase tracking-[0.14em] px-5 py-2 rounded-full border border-[#111]" data-testid="fb-live-test-disable">Disable</button>
        </div>
      )}
    </div>
  );
};
